module.exports = __webpack_public_path__ + "img/row.88cc2b15.svg";